/**
 * Phase 6e1 — shared confirm popups (§12.3/§12.4), markup faithful:
 *  - UniversalPopup (universal_popup.tmpl) — lug-defaults warnings (§7.3.2).
 *  - DeleteConfirmPopup (shared delete_popup.tmpl) — "Delete Lug?" /
 *    "Delete Internal Wall?" / "Delete D-Mount?".
 * The LOCAL view/delete_popup.js twin is dead ([NEG]#48 / #23) — not ported.
 */

export interface UniversalPopupProps {
  title: string;
  content: string;
  actionText?: string;
  cancelText?: string;
  onAction: () => void;
  onCancel: () => void;
}

export const UniversalPopup = ({
  title,
  content,
  actionText,
  cancelText,
  onAction,
  onCancel,
}: UniversalPopupProps) => (
  <div className="popup-wrapper active universal-popup-wrapper">
    <div className="popup-content universal-popup">
      <h2 className="popup-heading">{title}</h2>
      <div className="popup-content-part">
        <p>{content}</p>
      </div>
      <div className="popup-control-buttons">
        {actionText && (
          <button
            className="btn right highlighted-btn"
            autoFocus
            name="confirm_action"
            id="btn_action"
            onClick={onAction}
          >
            {actionText}
          </button>
        )}
        {cancelText && (
          <button
            className="btn right btn_cancel not-highlighted-btn"
            id="btn_cancel"
            name="cancel_action"
            onClick={onCancel}
          >
            {cancelText}
          </button>
        )}
      </div>
    </div>
  </div>
);

export interface DeleteConfirmPopupProps {
  title: string;
  content: string;
  name?: string | null;
  onDelete: () => void;
  onCancel: () => void;
}

export const DeleteConfirmPopup = ({
  title,
  content,
  name,
  onDelete,
  onCancel,
}: DeleteConfirmPopupProps) => (
  <div className="popup-wrapper width-small active">
    <div className="popup-content delete-popup">
      <h2 className="popup-heading">{title}</h2>
      <div className="popup-content-part">
        <p>{content}</p>
        <ul className="deleted-items">
          <li className="model-name">{name}</li>
        </ul>
      </div>
      <div className="popup-control-buttons">
        <button className="btn right not-highlighted-btn" name="confirm_delete" onClick={onDelete}>
          Delete
        </button>
        <button
          className="btn right btn_cancel highlighted-btn"
          id="btn_cancel"
          name="cancel_delete"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);
